<template>
  <section class="container_404">
    <section class="information">
      <div class="tips_title">
        We couldn't find the page you were looking for
      </div>
      <div class="tips_content">
        Looks like you're looking for a page that doesn't exist. go back or be
        sure to check the url, your spelling and try again.
      </div>
      <a class="backBtn" @click="backHomeHandler">GO TO HOME PAGE</a>
      <section class="innerBox">
        <div class="cp">All rights reserved, 2025 © TOTOK TECHNOLOGY LTD</div>
      </section>
    </section>
  </section>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "Terms of Use - ToTok Messenger",
      meta: [
        {
          Description:
            "ToTok provide you service with serious procedures and commitment"
        },
        { property: "og:title", content: "Terms of Use - ToTok Messenger" },
        { property: "og:url", content: "https://totok.ai/404" },
        { property: "og:type", content: "website" },
        {
          property: "og:image",
          content: "https://static.totok.ai/pic/preview/free_unblocked_call.png"
        },
        {
          property: "og:description",
          content:
            "Enjoy FREE, FAST and FUN calling with your family and friends."
        },
        { property: "og:site_name", content: "ToTok" }
      ]
    };
  },
  components: {},
  data() {
    return {
      showinfo: false,
      isActive: "terms",
      leftMenus: [
        {
          title: "Terms of Use",
          anchorId: "terms"
        },
        {
          title: "Privacy Policy",
          anchorId: "privacy"
        }
      ]
    };
  },
  computed: {
    info() {
      return [];
    }
  },
  methods: {
    backHomeHandler() {
      this.$router.push("/");
    }
  }
};
</script>
<style scoped lang="stylus">
.container_404{
    padding: 0.8rem;
     background: #fff;
     height: 97vh;
    .information{
        display: flex;
         flex-direction: column;
         justify-content: center;
         align-items: flex-start;
         width: 52vw;
         margin: 117px auto;
        .tips_title{
                direction: ltr;
                 font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                 -webkit-font-smoothing: antialiased;
                 text-rendering: optimizeLegibility;
                 border: 0;
                 margin: 0;
                 padding: 0;
                 vertical-align: baseline;
                 color: #232323;
                 font-size: 26px;
                 font-weight: 300;
                 line-height: 31px;
                 margin-bottom: 29px;
        }
        .tips_content{
                 direction: ltr;
                 font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                 -webkit-font-smoothing: antialiased;
                 text-rendering: optimizeLegibility;
                 border: 0;
                 margin: 0;
                 padding: 0;
                 vertical-align: baseline;
                 color: #5b5f62;
                 font-size: 18px;
                 line-height: 30px;
                 margin-bottom: 34px;
            }
        .innerBox{
                 position: absolute;
                 bottom: 30px;
                 left: 50%;
                 transform: translateX(-50%);
                 width:100%;
                 .cp{
                     height: 20px;
                     font-size: 13px;
                     color: #808080;
                     line-height: 70px;
                     text-align: center;
                 }
             }
             .backBtn{
                 font-size: 15px;
                 line-height: 23px;
                 padding: 12px 24px;
                 border: 1px solid #4377f2;
                 border-radius: 30px;
                 color: #fff;
                 background: #4377f2;
             }
    }
}
@media only screen and (max-width: 700px) {
             .container_404{
                 height: 92vh;
                 .information{
                     margin-top: 80px;
                     width:70vw;
                 }
             }

         }
</style>
